'use client'

import { useTranslations } from 'next-intl'

type Props = {
  text?: string | null
  ctaUrl?: string | null
}

/**
 * Banner de promoción: franja de acento con el mensaje del merchant y un CTA
 * opcional. Theme-aware (usa --ms-accent / --ms-radius / --ms-font-display).
 * Degrada — no renderiza — si no hay texto.
 */
export function PromoBanner({ text, ctaUrl }: Props) {
  const t = useTranslations('public.microsite')
  if (!text || !text.trim()) return null

  return (
    <section className="px-5 sm:px-8 pt-10 max-w-6xl mx-auto">
      <div
        className="relative overflow-hidden flex flex-col sm:flex-row items-center justify-between gap-4 px-6 sm:px-9 py-6 sm:py-7"
        style={{ background: 'var(--ms-accent)', borderRadius: 'calc(var(--ms-radius) * 1.2)' }}
      >
        <p
          className="text-white text-center sm:text-left text-[18px] sm:text-[23px] font-bold leading-snug"
          style={{ fontFamily: 'var(--ms-font-display)', textShadow: '0 1px 10px rgba(0,0,0,0.12)' }}
        >
          {text}
        </p>
        {ctaUrl && ctaUrl.trim() && (
          <a
            href={ctaUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 inline-flex items-center rounded-full bg-white px-6 py-3 text-[14px] font-bold transition hover:scale-[1.03] active:scale-95"
            style={{ color: 'var(--ms-accent)' }}
          >
            {t('promoCta')}
          </a>
        )}
      </div>
    </section>
  )
}
